import React from 'react';
import ReactDOM from "react-dom/client";
import { RouterProvider } from "react-router-dom";

import router from './Route';
import AuthProvider from './Firebase/AuthProvider';

// Kept out of the first bundle; it does nothing unless a verified boutique is signed in.
const BusinessCartSync = React.lazy(() => import("./Business/BusinessCartSync"));

const chunkReloadKey = 'maviinci:chunk-reload-attempted';
const isChunkLoadError = (error) => {
  const message = String(error?.message || error || '');
  return /Loading chunk \d+ failed|ChunkLoadError|CSS_CHUNK_LOAD_FAILED/i.test(message);
};
const recoverFromChunkLoadError = (error) => {
  if (!isChunkLoadError(error)) return;
  if (sessionStorage.getItem(chunkReloadKey)) return;

  sessionStorage.setItem(chunkReloadKey, '1');
  window.location.reload();
};

window.addEventListener('error', (event) => {
  recoverFromChunkLoadError(event.error || event.message);
});
window.addEventListener('unhandledrejection', (event) => {
  recoverFromChunkLoadError(event.reason);
});
window.addEventListener('load', () => {
  window.setTimeout(() => sessionStorage.removeItem(chunkReloadKey), 5000);
});

// In production, silence verbose console output. Many components in the
// customizer flow log large objects (Fabrics_all, useFabric, layers, etc.)
// inside hot paths; serializing them blocks the main thread on mobile.
// Keep console.warn/error so genuine problems remain visible.
if (process.env.NODE_ENV === 'production') {
  const noop = () => {};
  console.log = noop;
  console.debug = noop;
  console.info = noop;
  console.trace = noop;
}

const rootElement = document.getElementById('root');
const app = (
  <AuthProvider>
    <RouterProvider router={router} />
    <React.Suspense fallback={null}><BusinessCartSync /></React.Suspense>
  </AuthProvider>
);

// Static SEO shells are intentionally lightweight crawler fallbacks, not exact
// React server output. Clear them before mounting to avoid hydration mismatch
// errors while keeping the source HTML indexable for crawlers.
if (rootElement.hasChildNodes()) {
  rootElement.replaceChildren();
}

ReactDOM.createRoot(rootElement).render(app);

// The first-open loader in public/index.html stays until the first page is
// on screen: React has drawn something and no route loader is showing (a
// product grid still loading does not count). Ten seconds at most.
const bootLoader = document.getElementById('mv-boot');
if (bootLoader) {
  let finished = false;
  const finish = () => {
    if (finished) return;
    finished = true;
    observer.disconnect();
    bootLoader.classList.add('is-done');
    window.setTimeout(() => bootLoader.remove(), 450);
  };
  // The built stylesheet loads without blocking (scripts/generate-seo-shells.js);
  // keep the loader up until it has arrived, so nothing shows unstyled.
  const cssReady = () =>
    [...document.querySelectorAll('link[data-mv-css]')].every((l) => l.rel === 'stylesheet' && l.sheet);
  const ready = () => {
    if (!rootElement.firstElementChild || !cssReady()) return false;
    const loaders = rootElement.querySelectorAll('.mvl--page');
    return ![...loaders].some((el) => !el.closest('.cat-loading'));
  };
  const check = () => {
    if (!ready()) return;
    window.requestAnimationFrame(() => window.requestAnimationFrame(() => {
      if (ready()) finish();
    }));
  };
  const observer = new MutationObserver(check);
  observer.observe(rootElement, { childList: true, subtree: true });
  document.querySelectorAll('link[data-mv-css]').forEach((l) => l.addEventListener('load', () => setTimeout(check, 0)));
  window.setTimeout(finish, 10000);
  check();
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals

